import React, { useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { notUndefined, onlyUnique } from '../../../../../../../shared/lib/functional';
import Card from '../components/Card';
import Filters from '../components/Filters';
import TagsHoc from '../components/hoc/TagsHoc';
import { useData } from '../context/DataContext';
import { useFavorites } from '../context/FavoritesContext';
import { useQueryStrings } from '../context/QueryStringContext';

interface ExporePagePropsBase {}

type ExporePageProps = ExporePagePropsBase & RouteComponentProps;

function ExplorePage(_props: ExporePageProps) {
  const { todayLineup, data } = useData();
  const [activeFilters, setActiveFilters] = useState<string[]>([]);
  // const [isSimpleView] = useState<boolean>(false);
  const { favorites, toggleFavorite } = useFavorites();
  const { updateQs } = useQueryStrings();

  const filteredVenues = todayLineup.venues.filter(venue => {
    if (activeFilters.length === 0) return true;

    let filterCheck = true;

    activeFilters.forEach(filter => {
      switch (filter) {
        case data.appConfig.TRENDING_LABEL: {
          filterCheck = filterCheck && venue.isTrending;
        }
        case data.appConfig.OPEN_NOW_LABEL: {
          filterCheck = filterCheck && venue.isOpen;
          break;
        }
        default: {
          if (data.collections.venueTypes[filter]) {
            filterCheck =
              filterCheck && (venue.typeIds.length === 0 || venue.typeIds.includes(filter));
          } else if (data.collections.zones[filter]) {
            filterCheck =
              filterCheck && (venue.zoneIds.length === 0 || venue.zoneIds.includes(filter));
          }
          break;
        }
      }
    });

    return filterCheck;
  });

  const zoneKeys = Object.keys(data.collections.zones).map(e => data.collections.zones[e]._id);

  const venueTypeKeys = todayLineup.venues
    .map(v => v.typeIds)
    .flat()
    .filter(onlyUnique);

  return (
    <div id="ExplorePage">
      <Filters
        title={data.appConfig.EXPLORE_LABEL}
        icon={['far', 'compass']}
        staticButtons={[
          todayLineup.venues.find(v => v.isTrending) ? data.appConfig.TRENDING_LABEL : undefined,
          todayLineup.venues.find(v => v.isOpen) ? data.appConfig.OPEN_NOW_LABEL : undefined,
        ].filter(notUndefined)}
        keys={[...zoneKeys, ...venueTypeKeys]}
        onFilterChange={setActiveFilters}
        labelExtractor={(key: string) =>
          data.collections.venueTypes[key]?.name || data.collections.zones[key]?.name
        }
        rightSide={
          <div className="flex items-center -mr-4">
            <div className="px-4 font-semibold date-picker">{data.appConfig.TODAY_LABEL}</div>
          </div>
        }
      />

      <div className="grid gap-2 pb-8">
        {filteredVenues.map(venue => {
          return (
            <TagsHoc type="venue" item={venue} key={venue.templateId}>
              {props => (
                <Card
                  className="border-b"
                  onClick={() => updateQs('venue', venue.templateId)}
                  title={venue.venueString}
                  subtitle={venue.timeStrings}
                  image={venue.images[0]?.url}
                  tags={props.tags}
                  isFavorite={!!favorites.venues[venue.templateId]}
                  onFavoriteClick={() => toggleFavorite({ type: 'venues', value: venue })}
                />
              )}
            </TagsHoc>
          );
        })}
        {filteredVenues.length <= 0 && (
          <div className="italic text-slate px-4 pt-4 text-center">
            {data.appConfig.NO_RESULTS_TEXT}
          </div>
        )}
      </div>
    </div>
  );
}

export default ExplorePage;
